import React from 'react';

const LoadingState = ({ message = 'Generating your chart...' }) => (
  <div className="chart-state chart-state-loading" role="status" aria-live="polite">
    <p>{message}</p>
  </div>
);

export default LoadingState;
